import React from 'react';
import Select from 'react-select-plus'

class AUFDegrees extends React.Component {
  constructor(props) {
    super();

    this.dispatchReducer = props.dispatchReducer.bind(this);
    this._handleSelectChange = this._handleSelectChange.bind(this);

    this._hideDegreesWithoutUnits = this._hideDegreesWithoutUnits.bind(this);
  }

  render() {
    let avaiDegrees = this._hideDegreesWithoutUnits(this.props.avaiDegrees);

    return <fieldset>
      <legend className="sq-form-question-title">from</legend>

      <div className="sq-form-question-answer">
        <Select name="filter-degrees"
                options = {avaiDegrees.map(function(item){
                  return {label: item.name, value: item.name};
                })}
                value={this.props.currDegrees.join(',')}
                onChange = {this._handleSelectChange}
                placeholder={this.props.placeholderText}
                multi simpleValue
                disabled={this.props.isDegreeDisabled} />
      </div>
    </fieldset>;
  }

  _handleSelectChange(value) {
    let currDegrees = value.length === 0 ? [] : value.split(','); // in case value is emtpy string

    this.dispatchReducer({
      type:       'ALL_UNITS_DEGREES::UPDATE',
      value:      currDegrees,
      fireFilter: true
    });
  }

  _hideDegreesWithoutUnits(degrees) {
    let result = []

    for(var x in degrees) {
      if(degrees[x].units_count > 0){
        result.push(degrees[x]);
      }
    }
    return result;
  }
}

AUFDegrees.propTypes = {
  avaiDegrees:      React.PropTypes.array.isRequired,
  currDegrees:      React.PropTypes.array.isRequired,
  placeholderText:  React.PropTypes.string.isRequired,
  isDegreeDisabled: React.PropTypes.bool.isRequired,
  dispatchReducer:  React.PropTypes.func.isRequired
};

export default AUFDegrees;
